import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const Calculator: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 44"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        d="M33.0031 3.66748H11.0012C8.97594 3.66748 7.33417 5.30925 7.33417 7.33447V36.6704C7.33417 38.6956 8.97594 40.3374 11.0012 40.3374H33.0031C35.0283 40.3374 36.6701 38.6956 36.6701 36.6704V7.33447C36.6701 5.30925 35.0283 3.66748 33.0031 3.66748Z"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6717 11.001H29.3397"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M29.3361 25.6694V33.0034"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M29.3361 18.3345H29.3538"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22.0039 18.3345H22.0216"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6717 18.3345H14.6894"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22.0039 25.6694H22.0216"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6717 25.6694H14.6894"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22.0039 33.0029H22.0216"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.6717 33.0029H14.6894"
        stroke={color ?? 'currentColor'}
        strokeWidth="3.66699"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </IconWrapper>
);

Calculator.displayName = 'Calculator';
